import styled from 'styled-components';

export const SmallTitle = styled.h2`
  text-align: center;
  font-family: BrandonGrotesque-Medium;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #555555;
  padding-bottom: 10px;
`;
